import { createAction } from "@reduxjs/toolkit";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";
import type { SubmitBatchParticipationInvoiceBody } from "@shared-kernel/application/ports/educational-advisor/educational-advisor-repository";

export const submitBatchParticipationInvoice = createApiThunk<void, SubmitBatchParticipationInvoiceBody>(
  "batches/submitBatchParticipationInvoice",
  async (body, { extra: { educationalAdvisorRepository } }) => {
    return educationalAdvisorRepository!.submitParticipationInvoice(body);
  },
);

export const resetSubmitBatchParticipationInvoice = createAction("batches/resetSubmitBatchParticipationInvoice");
